/**
 * Hattan Luxury Perfumes - Product Description Horizontal Tabs
 * Transforms .hattan-tabs into horizontal tabs on desktop (>750px)
 * and keeps clean accordion behavior on mobile (<=750px).
 */
(function() {
  'use strict';

  function initHattanTabs() {
    var containers = document.querySelectorAll('.hattan-tabs');
    if (!containers || !containers.length) return;

    containers.forEach(function(container) {
      var detailsList = container.querySelectorAll(':scope > details');
      if (!detailsList.length) return;

      var nav = container.querySelector(':scope > .hattan-tabs__nav');

      // Create tab bar if it doesn't already exist
      if (!nav) {
        nav = document.createElement('div');
        nav.className = 'hattan-tabs__nav';
        nav.setAttribute('role', 'tablist');
        nav.setAttribute('aria-label', 'تبويبات تفاصيل المنتج');

        detailsList.forEach(function(detail, index) {
          var summary = detail.querySelector(':scope > summary');
          var titleText = summary ? summary.textContent.trim() : ('تبويب ' + (index + 1));

          // Replace "خبير هتان" with "خبير الموضة"
          titleText = titleText.replace(/خبير هتان/g, 'خبير الموضة');

          if (summary) {
            summary.childNodes.forEach(function(node) {
              if (node.nodeType === 3 && node.nodeValue && node.nodeValue.indexOf('خبير هتان') !== -1) {
                node.nodeValue = node.nodeValue.replace(/خبير هتان/g, 'خبير الموضة');
              }
            });
          }

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'hattan-tabs__btn';
          btn.setAttribute('role', 'tab');
          btn.setAttribute('data-tab-index', index);
          btn.setAttribute('aria-selected', 'false');
          btn.textContent = titleText;

          btn.addEventListener('click', function(e) {
            e.preventDefault();
            switchTab(container, detailsList, index);
          });

          nav.appendChild(btn);

          // Wrap content inside a dedicated container if not already wrapped
          if (!detail.querySelector(':scope > .hattan-tabs__content')) {
            var contentDiv = document.createElement('div');
            contentDiv.className = 'hattan-tabs__content';
            var nodes = Array.from(detail.childNodes).filter(function(node) {
              return node !== summary;
            });
            nodes.forEach(function(node) {
              contentDiv.appendChild(node);
            });
            detail.appendChild(contentDiv);
          }

          // Mobile summary toggle sync
          if (summary) {
            summary.addEventListener('click', function() {
              setTimeout(function() {
                if (detail.open) {
                  updateActiveTabUI(container, detailsList, index, false);
                }
              }, 15);
            });
          }
        });

        container.insertBefore(nav, detailsList[0]);
      }

      // Automatically unwrap parent accordion if inside .t4s-tab-wrapper
      var parentWrapper = container.closest('.t4s-tab-wrapper');
      if (parentWrapper) {
        var parentTitle = parentWrapper.querySelector(':scope > .t4s-tab__title');
        if (parentTitle) {
          parentTitle.style.setProperty('display', 'none', 'important');
        }
        parentWrapper.style.setProperty('border', 'none', 'important');
        var parentContent = parentWrapper.querySelector(':scope > .t4s-tab-content');
        if (parentContent) {
          parentContent.style.setProperty('display', 'block', 'important');
          parentContent.classList.add('t4s-active');
        }
      }

      // Determine initial active index (first detail with 'open', or index 0)
      var activeIndex = 0;
      var foundOpen = false;
      detailsList.forEach(function(detail, idx) {
        if (detail.hasAttribute('open') && !foundOpen) {
          activeIndex = idx;
          foundOpen = true;
        }
      });

      // Activate initial tab
      switchTab(container, detailsList, activeIndex);
    });
  }

  function updateActiveTabUI(container, detailsList, targetIndex, enforceSingleOpen) {
    var buttons = container.querySelectorAll(':scope > .hattan-tabs__nav > .hattan-tabs__btn');
    buttons.forEach(function(btn, idx) {
      if (idx === targetIndex) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-selected', 'false');
      }
    });

    var isDesktop = window.innerWidth > 750;

    detailsList.forEach(function(detail, idx) {
      if (idx === targetIndex) {
        detail.classList.add('is-active');
        detail.setAttribute('open', '');
      } else {
        detail.classList.remove('is-active');
        if (isDesktop || enforceSingleOpen) {
          detail.removeAttribute('open');
        }
      }
    });
  }

  function switchTab(container, detailsList, targetIndex) {
    updateActiveTabUI(container, detailsList, targetIndex, window.innerWidth > 750);
  }

  // Handle responsive window resize
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      var containers = document.querySelectorAll('.hattan-tabs');
      var isDesktop = window.innerWidth > 750;
      containers.forEach(function(container) {
        var detailsList = container.querySelectorAll(':scope > details');
        var activeBtn = container.querySelector(':scope > .hattan-tabs__nav > .hattan-tabs__btn.is-active');
        var activeIndex = activeBtn ? parseInt(activeBtn.getAttribute('data-tab-index'), 10) : 0;
        if (isDesktop) {
          detailsList.forEach(function(detail, idx) {
            if (idx === activeIndex) {
              detail.setAttribute('open', '');
              detail.classList.add('is-active');
            } else {
              detail.removeAttribute('open');
              detail.classList.remove('is-active');
            }
          });
        }
      });
    }, 100);
  });

  // DOM ready check
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHattanTabs);
  } else {
    initHattanTabs();
  }

  // Shopify section events & variants
  document.addEventListener('shopify:section:load', initHattanTabs);
  document.addEventListener('shopify:section:select', initHattanTabs);
  document.addEventListener('variant:changed', function() {
    setTimeout(initHattanTabs, 50);
  });

  // MutationObserver for dynamic Ajax / quickview content
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          for (var j = 0; j < mutations[i].addedNodes.length; j++) {
            var node = mutations[i].addedNodes[j];
            if (node.nodeType === 1) {
              if ((node.classList && node.classList.contains('hattan-tabs')) || (node.querySelector && node.querySelector('.hattan-tabs'))) {
                initHattanTabs();
                return;
              }
            }
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
